'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// Input the class base name, plus the modifiers (from props.className)
var classConcat = function classConcat(baseClass, modifiers) {
    var link = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '--';

    if (modifiers) {
        var modifiersArray = Array.isArray(modifiers) ? modifiers : [].concat(_toConsumableArray(modifiers.split(' ')));
        return modifiersArray.length ? modifiersArray.map(function (modifier) {
            return '' + baseClass + link + modifier;
        }).join(' ') : modifiersArray;
    }
    return null;
};
exports.default = classConcat;
//# sourceMappingURL=classConcat.js.map